import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzImageModule } from 'ng-zorro-antd/image';
import { SwiperModule } from 'swiper/angular';

import { LotMotoJupiterInspectionCardNotesComponent } from './components/lot-moto-jupiter-inspection-card-notes/lot-moto-jupiter-inspection-card-notes.component';
import { LotMotoJupiterInspectionCardSliderComponent } from './components/lot-moto-jupiter-inspection-card-slider/lot-moto-jupiter-inspection-card-slider.component';
import { LotMotoJupiterInspectionCardComponent } from './components/lot-moto-jupiter-inspection-card/lot-moto-jupiter-inspection-card.component';
import { LotMotoJupiterDataComponent } from './lot-moto-jupiter-data.component';
import { InspectionNoteTextPipe } from './pipes/inspection-note-text.pipe';
import { InspectionNoteTitlePipe } from './pipes/inspection-note-title.pipe';
import { InspectionTitlePipe } from './pipes/inspection-title.pipe';
import { LotMotoJupiterInspectionCardTitleComponent } from './components/lot-moto-jupiter-inspection-card-title/lot-moto-jupiter-inspection-card-title.component';
import { LotMotoJupiterInspectionCommentComponent } from './components/lot-moto-jupiter-inspection-comment/lot-moto-jupiter-inspection-comment.component';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { ThreeSixtyViewerModule } from '../three-sixty-viewer/three-sixty-viewer.module';

@NgModule({
  declarations: [
    LotMotoJupiterDataComponent,
    LotMotoJupiterInspectionCardComponent,
    LotMotoJupiterInspectionCardSliderComponent,
    LotMotoJupiterInspectionCardNotesComponent,
    InspectionTitlePipe,
    InspectionNoteTitlePipe,
    InspectionNoteTextPipe,
    LotMotoJupiterInspectionCardTitleComponent,
    LotMotoJupiterInspectionCommentComponent,
  ],
  imports: [
    CommonModule,
    SwiperModule,
    TranslateModule,
    NzGridModule,
    NzCardModule,
    NzCollapseModule,
    NzImageModule,
    NzAlertModule,
    NzIconModule,
    NzButtonModule,
    NzSpinModule,
    NzDividerModule,
    ThreeSixtyViewerModule,
  ],
  exports: [LotMotoJupiterDataComponent],
})
export class LotMotoJupiterDataModule {}
